import React, { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from './auth.jsx'
import { useConfig } from './config.jsx'
import { NotificationsBell } from './lib.jsx'
import AppIcon from './components/AppIcon.jsx'

const isPresentationEditor = pathname => /^\/presentations\/[^/]+\/editor\/?$/.test(pathname)

export default function Layout() {
  const { user, logout } = useAuth()
  const cfg = useConfig()
  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(() => isPresentationEditor(location.pathname))
  const [expanded, setExpanded] = useState({ ebooks: location.pathname === '/' || location.pathname.startsWith('/projects/'), presentations: location.pathname.startsWith('/migration') || location.pathname.startsWith('/presentations/') })
  useEffect(() => {
    setCollapsed(isPresentationEditor(location.pathname))
  }, [location.pathname])

  const toggleCollapsed = () => setCollapsed(value => !value)
  const toggleSection = key => {
    if (collapsed) {
      setCollapsed(false)
      setExpanded(value => ({ ...value, [key]: true }))
      return
    }
    setExpanded(value => ({ ...value, [key]: !value[key] }))
  }
  const item = (to, icon, label, end = false) => <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} title={collapsed ? label : undefined}
      className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
      <span className="ic"><AppIcon name={icon}/></span><span className="lbl">{label}</span>
    </NavLink>
  const section = (key, icon, label, children, badge = null) => <div className={`nav-section ${expanded[key] ? 'expanded' : ''}`}>
    <button type="button" className={`nav-section-toggle ${expanded[key] ? 'active' : ''}`} onClick={() => toggleSection(key)} aria-expanded={!!expanded[key]} title={collapsed ? label : undefined}>
      <span className="ic"><AppIcon name={icon}/></span><span className="lbl">{label}{badge && <span className="nav-progress-badge">{badge}</span>}</span><AppIcon name="chevronDown" size={15} className="nav-chevron"/>
    </button>
    {expanded[key] && !collapsed && <div className="nav-submenu">{children}</div>}
  </div>

  return <div className={`app ${collapsed ? 'sidebar-collapsed' : ''}`}>
    <button className="menu-btn" aria-label="Menu" onClick={() => setOpen(value => !value)}>☰</button>
    <div className={`nav-overlay ${open ? 'show' : ''}`} onClick={() => setOpen(false)}/>
    <aside className={`sidebar ${open ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}>
      <button className="inspector-handle sidebar-handle" title={collapsed ? 'Rozwiń menu' : 'Zwiń menu'} aria-label={collapsed ? 'Rozwiń menu' : 'Zwiń menu'} onClick={toggleCollapsed}><AppIcon name={collapsed ? 'chevronRight' : 'chevronLeft'} size={18}/></button>
      <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
      <div className="nav-label">Moje materiały</div>
      {section('ebooks', 'book', 'Ebooki / broszury PDF', item('/', 'create', 'Tworzenie i projekty', true), 'w trakcie realizacji')}
      {section('presentations', 'presentation', 'Prezentacje PPTX/PDF', <>
        {item('/migration', 'create', 'Tworzenie / import', true)}
        {item('/migration/projects', 'folder', 'Przeglądaj projekty')}
        {item('/migration/history', 'history', 'Historia importów')}
      </>)}
      {(cfg.features.billing || cfg.features.multi_organization) && <>
        <div className="nav-label">Konto</div>
        {cfg.features.billing && item('/billing', 'folder', 'Płatności')}
        {cfg.features.multi_organization && item('/organizations', 'users', 'Organizacje')}
      </>}
      {user?.role === 'admin' && <>
        <div className="nav-label">Panel admina</div>
        {item('/admin/users', 'users', 'Użytkownicy')}
        {item('/admin/templates', 'template', 'Szablony ebooków / broszur')}
        {item('/admin/migration-templates', 'template', 'Szablony prezentacji')}
        {item('/admin/projects', 'folder', 'Ebooki / broszury użytkowników')}
        {item('/admin/jobs', 'jobs', 'Zadania ebooków')}
        {item('/admin/migration-jobs', 'jobs', 'Zadania prezentacji')}
        {cfg.features.billing && item('/admin/billing/plans', 'folder', 'Plany')}
        {item('/admin/settings', 'settings', 'Ustawienia')}
      </>}
      <div className="spacer"/>
      {cfg.features.notifications && <NotificationsBell/>}
      <div className="user-box"><div className="who"><div className="avatar-dot">{(user?.username || '?')[0]?.toUpperCase()}</div><div className="user-details"><div style={{ fontWeight: 700, fontSize: 13 }}>{user?.username}</div><span className={`role-tag ${user?.role === 'admin' ? 'role-admin' : ''}`}>{user?.role}</span></div></div>
        <button className="btn btn-ghost btn-sm logout-button" title="Wyloguj" aria-label="Wyloguj" onClick={() => { logout(); navigate('/login') }}><AppIcon name="logout"/><span className="lbl">Wyloguj</span></button>
      </div>
    </aside>
    <main className="main"><Outlet/></main>
  </div>
}
